import type { ImpiantoDelParco } from '../SimulatorParco';
import { impiantoCstai, impiantoCstaiColonica, impiantoCstaiMinimo } from './cstai';
import { impiantoEcobel, impiantoEcobelBifamiliare, impiantoEcobelCondominio } from './ecobel';

/** Parco impianti CSTAI: tre centraline Ema Comfort, una irraggiungibile. */
export function parcoCstai(): ImpiantoDelParco[] {
  return [
    { impianto: impiantoCstai() },
    { impianto: impiantoCstaiMinimo(), scenario: { raggiungibile: false } },
    { impianto: impiantoCstaiColonica(), scenario: { sondeScollegate: ['A15'], allarmeDeltaT: true } },
  ];
}

/** Parco impianti Ecobel: tre impianti con sistemi di terzi, uno con il fotovoltaico caduto. */
export function parcoEcobel(): ImpiantoDelParco[] {
  return [
    { impianto: impiantoEcobel() },
    { impianto: impiantoEcobelBifamiliare(), scenario: { sorgentiIrraggiungibili: ['fv'] } },
    { impianto: impiantoEcobelCondominio(), scenario: { allarmeDeltaT: true } },
  ];
}

/** Parco neutro (marchio Ema Comfort): un impianto per tipo. */
export function parcoEmaComfort(): ImpiantoDelParco[] {
  return [{ impianto: impiantoCstai() }, { impianto: impiantoEcobel() }];
}
